module.exports = __webpack_public_path__ + "assets/failure-8fafac.svg";